"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgDeliveryBikeFilled = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.064 4.303-.011-.01-2.078-1.681c-1.138-.965-2.765-.768-3.692.44L3.6 5.031l-.019.023c-.433.579-.646 1.277-.563 1.978.082.702.453 1.334 1.046 1.785l1.162.93c.027.026.055.052.085.076l4.83 3.878c.129.135.181.276.19.38a.336.336 0 0 1-.104.278c-.026.027-.05.054-.072.084l-.166.214a4.5 4.5 0 1 0 .942 2.053.927.927 0 0 0 .026-.032l.752-.976c1.006-1.092.697-2.596-.206-3.467a.967.967 0 0 0-.068-.06L9.284 10.45c.145-.112.28-.24.405-.386l.01-.01 1.68-2.078c.96-1.13.772-2.74-.315-3.672ZM6.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z", fill: color }),
        React.createElement("path", { d: "M12.224 8.37a1 1 0 0 1 1.407-.146l3.2 2.6a1 1 0 1 1-1.262 1.552l-3.2-2.6a1 1 0 0 1-.145-1.407ZM16 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 13a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM15 17.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgDeliveryBikeFilled);
//# sourceMappingURL=SvgDeliveryBikeFilled.js.map